var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import * as prettier from 'prettier';
import htmlParser from 'prettier/parser-html';
export function ResponseBody({ content, contentType }) {
    const [formatted, setFormatted] = useState(content);
    const [raw, setRaw] = useState(false);
    useEffect(() => {
        if (!contentType) {
            return;
        }
        const format = () => __awaiter(this, void 0, void 0, function* () {
            try {
                if (contentType.match(/^text\/html(|;.*)$/)) {
                    const formatted = yield prettier.format(content, { parser: 'html', plugins: [htmlParser] });
                    setFormatted(formatted);
                }
                else if (contentType.match(/^application\/(|.*\+)json(|;.*)$/)) {
                    const formatted = JSON.stringify(JSON.parse(content), null, '  ');
                    setFormatted(formatted);
                }
            }
            catch (_a) { }
        });
        format();
    }, [content, contentType]);
    return (_jsxs("div", { className: "relative h-full", children: [_jsx("pre", { className: "h-full overflow-scroll text-wrap p-2 text-xs text-zinc-600 dark:text-white/60", children: _jsx("code", { children: raw ? content : formatted }) }), formatted && (_jsx("button", { className: 'absolute right-0 top-0 mr-1 mt-1 text-nowrap rounded bg-black/30 px-2 py-1 text-xs font-semibold text-white shadow-sm backdrop-blur hover:bg-black/80 dark:bg-white/15 dark:text-zinc-950 dark:hover:bg-white/80', onClick: () => {
                    setRaw(!raw);
                }, children: raw ? 'View Formatted' : 'View Original' }))] }));
}
